import React from 'react';

const Header = () => {
  const headerStyle = {
    backgroundColor: 'black',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const logoStyle = {
    height: '40px',
    width: 'auto',
  };

  return (
    <header style={headerStyle}>
      <img
        src="/mmlogo.png" 
        alt="Logo"
        style={logoStyle}
      />
    </header>
  );
};

export default Header;
